import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';

import { addNotification } from 'actions/NotificationsActions';

import Tabs from 'components/layout/Tabs';
import Loader from 'components/layout/Loader';

import ShareableResourceTeams from 'components/layout/shareable/ShareableResourceTeams';
import ShareableResourceUsers from 'components/layout/shareable/ShareableResourceUsers';
import ShareableResourceCompanies from 'components/layout/shareable/ShareableResourceCompanies';
import ShareableResourceSettings from 'components/layout/shareable/ShareableResourceSettings';

class ShareableResourceDetails extends React.Component {
  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      deleterStatus,
      doNotify,
    } = this.props;

    if (!formStatus.pending && !formStatus.hasError && prevProps.formStatus.pending) {
      doNotify(1, messages.share_settings_updated);
    }

    if (!deleterStatus.pending && !deleterStatus.hasError && prevProps.deleterStatus.pending) {
      doNotify(1, messages.share_settings_updated);
    }
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      data,
      type,
      id,
    } = this.props;

    const tabs = [];
    if (!data.pending) {
      tabs.push(
        <React.Fragment key="teams">
          {messages.teams}

          {!!data.data.teams.length && (
            <div className="inline m-l-10 bg-white b-rad-lg text-master-light p-l-5 p-r-5 hint-text">
              {data.data.teams.length}
            </div>
          )}
        </React.Fragment>
      );
      tabs.push(
        <React.Fragment key="users">
          {messages.users}

          {!!data.data.users.length && (
            <div className="inline m-l-10 bg-white b-rad-lg text-master-light p-l-5 p-r-5 hint-text">
              {data.data.users.length}
            </div>
          )}
        </React.Fragment>
      );
      tabs.push(
        <React.Fragment key="companies">
          {messages.companies}

          {!!data.data.companies.length && (
            <div className="inline m-l-10 bg-white b-rad-lg text-master-light p-l-5 p-r-5 hint-text">
              {data.data.companies.length}
            </div>
          )}
        </React.Fragment>
      );

      if (data.data.is_user_authorized) {
        tabs.push(<React.Fragment key="settings">{messages.settings}</React.Fragment>);
      }
    }

    const commonProps = !data.pending && {
      type,
      id,
      mayRemove: data.data.may_remove,
      mayShare: data.data.may_share,
    };

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.share}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!data.pending ? (
            <Tabs
              tabStyle="arrow"
              tabResponsiveStyle="stack"
              tabs={tabs}
              tabContent={[
                <ShareableResourceTeams list={data.data.teams} {...commonProps} key="teams" />,
                <ShareableResourceUsers list={data.data.users} {...commonProps} key="users" />,
                <ShareableResourceCompanies list={data.data.companies} {...commonProps} key="companies" />,
                <ShareableResourceSettings data={data.data} {...commonProps} key="settings" />,
              ]}
            />
          ) : (
            <Loader />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.share,
    deleterStatus: state.deleter.share,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ShareableResourceDetails)
);
